import config from '../config/backend';

export const AVATAR_SIZES = [64, 128, 256];
const AVATAR_KEY_REGEX = /^[a-f0-9]{24}-\d+$/;

// Smallest stored variant that stays sharp on a 2x screen for a given CSS size.
export const pickAvatarSize = (px) => {
  const target = (px || 35) * 2;
  return AVATAR_SIZES.find((s) => s >= target) || AVATAR_SIZES[AVATAR_SIZES.length - 1];
};

// Returns null for missing or legacy keys (old "IMAGE-*.png" uploads), so callers fall back to initials.
export const avatarUrl = (key, px) => {
  if(!key || !AVATAR_KEY_REGEX.test(key)){ return null; }
  return `${config.backend.uri}/static/uploads/avatars/${key}/${pickAvatarSize(px)}.webp`;
};
